export default "__VITE_ASSET__39a04590__"